<mf-page title="Tracking">
  <mf-track-grid [id]="id" />
</mf-page>
